/* eslint-disable react/prop-types */
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  setState,
} from "react";
import { InputGroup, FormControl, Button } from "react-bootstrap";
import { FaEdit, FaRegSave, FaTimes, FaCheck } from "react-icons/fa";

// Styles
import "./EditableTextInput.scss";

function EditableTextInput(props) {
  let nameLength =
    props.value && props.value.length > 0 ? props.value.length : 0;
  const [name, setName] = useState(props.name);
  const [type, setType] = useState(props.type || "text");
  const [value, setValue] = useState(props.value || "");
  const [backup, setBackup] = useState(props.backup || "");
  const [editClassName, setEditClassName] = useState(props.editClassName);
  const [edit, setEdit] = useState(false);

  const [length, setLength] = useState(nameLength);
  const [blurMode, setBlurMode] = useState("blur");

  const editHandler = () => {
    setEdit(true);
  };

  let cancelHandler = (e) => {
    setBlurMode("cancel");
    setEdit(false);
    setValue(backup);
    setLength(backup.length);
    props.onNameChange(backup);
  };

  let saveHandler = (e) => {
    setBlurMode("save");
    setEdit(false);
    props.onNameChange(value);
  };

  const maxInputWidth = props.maxWidth;

  const inputStyle = {
    flex: "none",
    width: length * 1.1 + "em",
    maxWidth: maxInputWidth + "em",
    minWidth:
    length * 1.1 < maxInputWidth
      ? length * 1.1 + 3 + "em"
      : maxInputWidth + "em",
  };

  const handleEvent = (event, type) => {
    switch (type) {
      case "save":
        saveHandler(event);
        break;
      case "cancel":
        cancelHandler(event);
        break;
      case "blur":
        cancelHandler(event);
        break;
      default:
        cancelHandler(event);
        break;
    }
  };

  return (
    (edit === true && type !== "textarea" && (
      <>
        <InputGroup className="mb-3 editable-text-input">
          <input
            style={inputStyle}
            name={name}
            type={type}
            value={value}
            className={editClassName}
            autoFocus
            onFocus={(event) => {
              const value = event.target.value;
              event.target.value = "";
              event.target.value = value;
              setBackup(value);
            }}
            onChange={(event) => {
              setLength(event.target.value.length);
              setValue(event.target.value);
            }}
            onBlur={(event) => {
              handleEvent(event, "blur");
            }}
            onKeyUp={(event) => {
              if (event.key === "Escape") {
                setEdit(false);
                setValue(backup);
                setLength(backup.length);
              }
              if (event.key === "Enter") {
                setEdit(false);
                props.onNameChange(value);
              }
            }}
          />
          <InputGroup.Append>
            <Button
              style={{ minWidth: '10px' }}
              id="editable-text-input__cancel-button"
              variant="outline-secondary"
              onMouseDown={(event) => handleEvent(event, "cancel")}
            >
              <FaTimes />
            </Button>
            <Button
              style={{ minWidth: '10px' }}
              id="editable-text-input__save-button"
              variant="outline-secondary"
              onMouseDown={(event) => handleEvent(event, "save")}
            >
              <FaCheck />
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </>
    )) ||
    (edit === true && type === "textarea" && (
      <>
        <textarea
          name={name}
          value={value}
          className={editClassName}
          autoFocus
          onFocus={(event) => {
            const value = event.target.value;
            event.target.value = "";
            event.target.value = value;
            setBackup(value);
          }}
          onChange={(event) => {
            setValue(event.target.value);
          }}
          onBlur={(event) => {
            handleEvent(event, "blur");
          }}
          onKeyUp={(event) => {
            if (event.key === "Escape") {
              setEdit(false);
              setValue(backup);
              setLength(backup.length);
            }
            if (event.key === "Enter") {
              setEdit(false);
              props.onNameChange(value);
            }
          }}
        ></textarea>
        <br />
      </>
    )) || (
      <span className="clickable" onClick={editHandler}>
        <h2>
          {value}{" "}
          <sup>
            <small>
              <FaEdit />
            </small>
          </sup>
        </h2>
      </span>
    )
  );
}

export default EditableTextInput;
